<div class="text-center" *hasPermission="permissionTypes.ModifyAdminUsers">
  <button mat-icon-button [matMenuTriggerFor]="menu"
          data-testid="open-admin-user-menu-button">
    <mat-icon matTooltipPosition="right"
              matTooltip="open admin user menu"
    >more_horiz
    </mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  @if (rowData.Active) {
    <button mat-menu-item
            (click)="onDeactivateUserClick()"
            data-testid="deactivate-user-menu-option">
      <mat-icon>do_disturb</mat-icon>
      <span>Deactivate</span>
    </button>
  } @else {
    <button mat-menu-item
            (click)="onReactiveUserClick()"
            data-testid="reactivate-user-menu-option">
      <mat-icon>refresh</mat-icon>
      <span>Reactivate</span>
    </button>
  }

  @if (!rowData.ConfirmedOn) {
    <button mat-menu-item
            (click)="onResendInviteClick()"
            data-testid="resend-user-invite-menu-option"
            [disabled]="uiState === uiStateEnumForTemplate.ShowLoading">
      @if (uiState === uiStateEnumForTemplate.ShowLoading) {
        <mat-spinner class="center-margin"></mat-spinner>
      } @else {
        <mat-icon class="dark-grey">send</mat-icon>
        <span class="dark-grey menu-text">Resend Invite</span>
      }
    </button>
  }
</mat-menu>
